/**
 * Internal dependencies
 */
import BlockPopin from "./block-popin";
import ViewportManager from "./viewport-manager";

/**
 * 
 */
class BlockPopinManager {

	/**
	 * 
	 */
	constructor()
	{
		this.init();

		this.popinList = [];
		this.popinSelector = '.wmu-block.block-popin';
		this.triggerList = [];
		this.triggerSelector = '.wmu-trigger-popin';
	}

	/**
	 * 
	 */
	init()
	{
		this.onViewportChange = this.onViewportChange.bind( this );
		document.addEventListener( 'WMUViewportChange', this.onViewportChange );

		this.onTriggerClick = this.onTriggerClick.bind( this );
	}

	/**
	 * 
	 */
	clear()
	{
		this.popinList.forEach( ( popin ) =>
		{
			popin.clear();
		} );
		
		this.popinList = [];

		this.triggerList.forEach( ( triggerElement ) =>
		{
			triggerElement.wmuBlockPopin = undefined;
			triggerElement.removeEventListener( 'click', this.onTriggerClick );
		} );

		this.triggerList = [];
	}

	/**
	 * 
	 */
	setup()
	{
		/**
		 * Create popins
		 */
		document.querySelectorAll( this.popinSelector ).forEach( ( popinElement ) =>
		{
			if ( popinElement.wmuBlockPopin )
			{
				return;
			}

			const popin = new BlockPopin( popinElement );
			this.popinList.push( popin );
		} );

		/**
		 * Activate triggers
		 */
		document.querySelectorAll( this.triggerSelector ).forEach( ( triggerElement ) =>
		{
			if ( triggerElement.wmuBlockPopin )
			{
				return;
			}

			/**
			 * Search for the associated popin
			 */
			triggerElement.classList.forEach( ( cssClass ) =>
			{
				if ( -1 !== cssClass.indexOf( 'popin-id-' ) )
				{
					const popin = this.getPopinById( cssClass.substring( 9 ) );
					triggerElement.wmuBlockPopin = popin;
					triggerElement.addEventListener( 'click', this.onTriggerClick );
				}
			} );
		} );
	}

	/**
	 * 
	 * @param {String} id 
	 */
	getPopinById( id )
	{
		let popin = null;

		this.popinList.forEach( ( _popin ) =>
		{
			if ( id === _popin.id )
			{
				popin = _popin;
				return;
			}
		} );

		return popin;
	}

	/**
	 * 
	 * @param {Event} event 
	 */
	onTriggerClick( event )
	{
		if ( ! event.target )
		{
			return;
		}

		const trigger = ( event.target.classList.contains( 'wmu-trigger-popin' ) ) ? event.target : event.target.closest( this.triggerSelector );

		if ( ! trigger.wmuBlockPopin )
		{
			return;
		}

		/**
		 * Ok ici on va vérifier le mode de positionnement et si trigger et si la popin n'est pas déjà affiché
		 * on déclenchera le positionnement en fonction du trigger via une méthode sur la popin.
		 * 
		 * popin.setPositionFromElement( trigger );
		 * 
		 * On mettra en param optionnel la possibilité de passer des paramètres pour à terme moduler la façon de
		 * positionner par rapport à l'élément.
		 */
		if ( false === trigger.wmuBlockPopin.isDisplayed )
		{
			const pos = trigger.wmuBlockPopin.element.getAttribute( `${ViewportManager.viewportCurrent.toLowerCase()}-pos` );
			
			switch ( pos )
			{
				case 'trigger':
					trigger.wmuBlockPopin.setPositionFromElement( trigger );
					break;
				
				case 'trigger-right':
					trigger.wmuBlockPopin.setPositionFromElement( trigger, { h: 'right' } );
					break;
			}
		}

		trigger.wmuBlockPopin.toggleDisplay();
		event.preventDefault();
		return false;
	}

	/**
	 * 
	 * @param {Event} event 
	 */
	onViewportChange( event )
	{
		this.clear();
		this.setup();
	}

}

export default BlockPopinManager;
